import { render } from "./ForbiddenPage.vue?vue&type=template&id=73cf0cb2&scoped=true"
import script from "./ForbiddenPage.vue?vue&type=script&lang=js"
export * from "./ForbiddenPage.vue?vue&type=script&lang=js"

import "./ForbiddenPage.vue?vue&type=style&index=0&id=73cf0cb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73cf0cb2"

export default script